<template>
  <span v-if="type">
    <span v-if="'person'.includes(type.toLowerCase())">
      <template v-if="includeText">
        <v-chip small>
          Person
          <v-icon
            right
            small
          >
            mdi-account
          </v-icon>
        </v-chip></template
      >
      <template v-else>
        <v-icon small> mdi-account </v-icon>
      </template>
    </span>

    <span v-else-if="'organization'.includes(type.toLowerCase())">
      <template v-if="includeText">
        <v-chip small>
          Organization
          <v-icon
            right
            small
          >
            mdi-office-building
          </v-icon>
        </v-chip>
      </template>
      <template v-else> <v-icon small> mdi-office-building </v-icon></template>
    </span>

    <span v-else-if="'vessel'.includes(type.toLowerCase())">
      <template v-if="includeText">
        <v-chip small>
          Vessel
          <v-icon
            right
            small
          >
            mdi-ferry
          </v-icon>
        </v-chip></template
      >
      <template v-else> <v-icon small> mdi-anchor </v-icon></template>
    </span>
  </span>
  <span v-else> </span>
</template>

<script>
export default {
  name: "CaseReport",
  props: {
    type: {
      type: String,
    },
    includeText: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
